import { render, staticRenderFns } from "./TypeOfProperty.vue?vue&type=template&id=e750e32c&"
import script from "./TypeOfProperty.vue?vue&type=script&lang=ts&"
export * from "./TypeOfProperty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports